import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { ICardSubcardsPanelButton } from './types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { CARD_SECTION_SUBCARDS } from '../CardSubcardsSection/constants';
import { CLASS_CARD_DETAILS_SECTION, SECTION_CREATION_WAITING_TIME } from '../../../constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { getAsidePanelActionsButtonTooltip } from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';

export function CardSubcardsPanelButton({
    isEssentialFeature,
    isDisallow,
    isShow,
    subcardsCount,
    tooltip,
    onClick
}: ICardSubcardsPanelButton) {
    if (!isShow) return null;

    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--subcards';

    const { showedProperties, addShowedProperty, isCommentsColumn } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_SUBCARDS);
    const [isOpened, setIsOpened] = React.useState(null);
    const onOpened = () => setIsOpened(true);
    const onClosed = () => setIsOpened(false);

    return (
        <AsidePanelActionsButton
            indicatorNumber={subcardsCount}
            icon={'subcard'}
            isDisabled={isDisallow}
            isEssentialFeature={isEssentialFeature}
            isIconHiddenOnFullSize={true}
            isOpened={isOpened}
            openedProperty={EAsidePanelProperty.CARD_SUBCARDS}
            sectionSelector={`.${classNameSection}`}
            title={CARD_SECTION_SUBCARDS}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_SUBCARDS, isCommentsColumn);
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, SECTION_CREATION_WAITING_TIME);
                }
            }}
            onOpen={onOpened}
        >
        </AsidePanelActionsButton>
    );
}
